"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveUninstallFeedback = exports.getPauseProgress = exports.pauseAllRules = exports.importRulesCsv = exports.exportRulesCsv = exports.importRules = exports.exportRules = exports.getUninstallStatus = exports.markNotificationAsRead = exports.shopNotifies = exports.getShopStorage = exports.setShopStorage = exports.setCrossSellSettings = exports.setSalesBadgeSettings = exports.setBogoFabSettings = exports.setBogoModalSettings = exports.setBundleEmbedSettings = exports.setComingSoonClicked = exports.setDiscountProgressBarSettings = exports.setShippingEmbedSettings = exports.setInventoryEmbedSettings = exports.setcartEmbedSettings = exports.getMoqPreferences = exports.setMoqPreferences = exports.getMoqDesignSettings = exports.setMoqDesignSettings = exports.setproductEmbedSettings = exports.setProductCountdownSettings = exports.changeDiscountNotes = exports.setWeeklyDigest = exports.emailUnsubscribe = exports.getShopLocales = exports.getVendors = exports.getShopMetafields = exports.getCustomerMetafields = exports.getVariantMetafields = exports.getProductTags = exports.getProductTypes = exports.getThemeEnabled = exports.hasThemeAccess = exports.hasCustomerAccess = exports.getB2bSignals = exports.getShopInfo = exports.shopIsInstalled = void 0;
const fetchInstance_1 = require("../../../utils/fetchInstance");
/**
* @summary Check shop exists and installed
*/
const shopIsInstalled = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/isInstalled`, method: 'get',
        params
    });
};
exports.shopIsInstalled = shopIsInstalled;
/**
* @summary Get shop info
*/
const getShopInfo = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/info`, method: 'get'
    });
};
exports.getShopInfo = getShopInfo;
/**
* @summary Smart B2B detection signals (product costs + customer segments)
*/
const getB2bSignals = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/b2b-signals`, method: 'get'
    });
};
exports.getB2bSignals = getB2bSignals;
/**
* @summary has customer access
*/
const hasCustomerAccess = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/has_customer_access`, method: 'get'
    });
};
exports.hasCustomerAccess = hasCustomerAccess;
/**
* @summary has theme access
*/
const hasThemeAccess = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/has_theme_access`, method: 'get'
    });
};
exports.hasThemeAccess = hasThemeAccess;
/**
* @summary Get Theme Enabled
*/
const getThemeEnabled = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/themeEnabled`, method: 'get'
    });
};
exports.getThemeEnabled = getThemeEnabled;
/**
* @summary Get list of product types
*/
const getProductTypes = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/productTypes`, method: 'get'
    });
};
exports.getProductTypes = getProductTypes;
/**
* @summary Get list of Product Tags
*/
const getProductTags = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/productTags`, method: 'get'
    });
};
exports.getProductTags = getProductTags;
/**
* @summary Get list of variant (PRODUCTVARIANT) metafield definitions
*/
const getVariantMetafields = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/variant-metafields`, method: 'get'
    });
};
exports.getVariantMetafields = getVariantMetafields;
/**
* @summary Get list of customer metafield definitions (namespace "custom")
*/
const getCustomerMetafields = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/customer-metafields`, method: 'get'
    });
};
exports.getCustomerMetafields = getCustomerMetafields;
/**
* @summary Get list of the shop's own metafield definitions (namespace "custom")
*/
const getShopMetafields = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/shop-metafields`, method: 'get'
    });
};
exports.getShopMetafields = getShopMetafields;
/**
* @summary Get list Vendors
*/
const getVendors = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/vendors`, method: 'get'
    });
};
exports.getVendors = getVendors;
/**
* @summary Get the shop's published languages (Settings > Languages), fetched live from Shopify
*/
const getShopLocales = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/locales`, method: 'get'
    });
};
exports.getShopLocales = getShopLocales;
/**
* @summary One-click unsubscribe from weekly digest (public, no auth)
*/
const emailUnsubscribe = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/email/unsubscribe`, method: 'get',
        params
    });
};
exports.emailUnsubscribe = emailUnsubscribe;
/**
* @summary Enable or disable weekly analytics digest email
*/
const setWeeklyDigest = (setWeeklyDigestBody) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/weeklyDigest`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: setWeeklyDigestBody
    });
};
exports.setWeeklyDigest = setWeeklyDigest;
/**
* @summary Change discount notes
*/
const changeDiscountNotes = (changeDiscountNotesBody) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/discountNotes`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: changeDiscountNotesBody
    });
};
exports.changeDiscountNotes = changeDiscountNotes;
/**
* @summary Set product discount settings
*/
const setProductCountdownSettings = (productCountdownSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/productCountdownSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: productCountdownSettingsDto
    });
};
exports.setProductCountdownSettings = setProductCountdownSettings;
/**
* @summary Set product discount settings
*/
const setproductEmbedSettings = (productEmbedSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/productEmbedSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: productEmbedSettingsDto
    });
};
exports.setproductEmbedSettings = setproductEmbedSettings;
/**
* @summary Set MOQ restriction badge design settings
*/
const setMoqDesignSettings = (moqDesignSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/moqDesignSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: moqDesignSettingsDto
    });
};
exports.setMoqDesignSettings = setMoqDesignSettings;
/**
* @summary Get MOQ restriction badge design settings
*/
const getMoqDesignSettings = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/moqDesignSettings`, method: 'get'
    });
};
exports.getMoqDesignSettings = getMoqDesignSettings;
/**
* @summary Set MOQ product-page behaviour preferences
*/
const setMoqPreferences = (moqPreferencesDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/moqPreferences`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: moqPreferencesDto
    });
};
exports.setMoqPreferences = setMoqPreferences;
/**
* @summary Get MOQ product-page behaviour preferences
*/
const getMoqPreferences = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/moqPreferences`, method: 'get'
    });
};
exports.getMoqPreferences = getMoqPreferences;
/**
* @summary Set product discount settings
*/
const setcartEmbedSettings = (cartEmbedSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/cartEmbedSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: cartEmbedSettingsDto
    });
};
exports.setcartEmbedSettings = setcartEmbedSettings;
/**
* @summary set Inventory Embed Settings
*/
const setInventoryEmbedSettings = (inventoryEmbedSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/InventoryEmbedSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: inventoryEmbedSettingsDto
    });
};
exports.setInventoryEmbedSettings = setInventoryEmbedSettings;
/**
* @summary Set shipping embed settings
*/
const setShippingEmbedSettings = (shippingEmbedSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/shippingEmbedSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: shippingEmbedSettingsDto
    });
};
exports.setShippingEmbedSettings = setShippingEmbedSettings;
/**
* @summary Set discount progress bar widget settings
*/
const setDiscountProgressBarSettings = (discountProgressBarSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/discountProgressBarSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: discountProgressBarSettingsDto
    });
};
exports.setDiscountProgressBarSettings = setDiscountProgressBarSettings;
/**
* @summary Set ComingSoon
*/
const setComingSoonClicked = (setComingSoonClickedDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/setComingSoonClicked`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: setComingSoonClickedDto
    });
};
exports.setComingSoonClicked = setComingSoonClicked;
/**
* @summary set Bundle Embed Settings
*/
const setBundleEmbedSettings = (bundleEmbedSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/BundleEmbedSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: bundleEmbedSettingsDto
    });
};
exports.setBundleEmbedSettings = setBundleEmbedSettings;
/**
* @summary set Bogo Modal Settings
*/
const setBogoModalSettings = (bogoModalSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/BogoModalSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: bogoModalSettingsDto
    });
};
exports.setBogoModalSettings = setBogoModalSettings;
/**
* @summary set Bogo FAB Settings
*/
const setBogoFabSettings = (bogoFabSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/BogoFabSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: bogoFabSettingsDto
    });
};
exports.setBogoFabSettings = setBogoFabSettings;
/**
* @summary set Sales Badge Settings
*/
const setSalesBadgeSettings = (salesBadgeSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/SalesBadgeSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: salesBadgeSettingsDto
    });
};
exports.setSalesBadgeSettings = setSalesBadgeSettings;
/**
* @summary set Cross Sell Settings
*/
const setCrossSellSettings = (crossSellSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/CrossSellSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: crossSellSettingsDto
    });
};
exports.setCrossSellSettings = setCrossSellSettings;
/**
* @summary Set list of key value storage
*/
const setShopStorage = (shopStorageDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/storage`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: shopStorageDto
    });
};
exports.setShopStorage = setShopStorage;
/**
* @summary get list of key value storage with filter
*/
const getShopStorage = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/storage`, method: 'get',
        params
    });
};
exports.getShopStorage = getShopStorage;
/**
* @summary shop notifies
*/
const shopNotifies = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/shop_notifies`, method: 'get'
    });
};
exports.shopNotifies = shopNotifies;
/**
* @summary Mark a notification as read
*/
const markNotificationAsRead = (markNotificationAsReadBody) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/mark_notification_as_read`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: markNotificationAsReadBody
    });
};
exports.markNotificationAsRead = markNotificationAsRead;
/**
* @summary Get safe-uninstall status for the shop
*/
const getUninstallStatus = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/uninstall-status`, method: 'get'
    });
};
exports.getUninstallStatus = getUninstallStatus;
/**
* @summary Export rule history as encoded payload
*/
const exportRules = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/export-rules`, method: 'get'
    });
};
exports.exportRules = exportRules;
/**
* @summary Import rules from a previously exported payload
*/
const importRules = (importRulesDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/import-rules`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: importRulesDto
    });
};
exports.importRules = importRules;
/**
* @summary Pro feature E — export rules as CSV (the fields you bulk-edit, not the complete format)
*/
const exportRulesCsv = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/export-rules-csv`, method: 'get'
    });
};
exports.exportRulesCsv = exportRulesCsv;
/**
* @summary Pro feature E — import/update rules from CSV. Blank scope columns leave that relation untouched.
*/
const importRulesCsv = (importRulesCsvDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/import-rules-csv`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: importRulesCsvDto
    });
};
exports.importRulesCsv = importRulesCsv;
/**
* @summary Pause all active rules for the shop
*/
const pauseAllRules = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/pause-all-rules`, method: 'post'
    });
};
exports.pauseAllRules = pauseAllRules;
/**
* @summary Returns count of rules still being deactivated — poll until safe=true
*/
const getPauseProgress = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/pause-progress`, method: 'get'
    });
};
exports.getPauseProgress = getPauseProgress;
/**
* @summary Save uninstall feedback reason and note
*/
const saveUninstallFeedback = (uninstallFeedbackDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/uninstall-feedback`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: uninstallFeedbackDto
    });
};
exports.saveUninstallFeedback = saveUninstallFeedback;
